var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 1.28855e-07 37.3137 0 34V6C0 2.68629 2.68629 1.28851e-07 6 0H34ZM15.3662 10.0215C13.2475 10.3369 9.23227 9.81329 7.52051 11.1865C5.9911 12.4149 5.87012 15.8899 5.78125 17.7256C5.65568 20.3318 5.67536 23.2753 6.1377 25.8398C6.7482 29.2302 8.33074 29.4926 11.4844 29.749C16.286 30.1395 21.4198 30.0051 26.2285 29.8115C28.0652 29.7372 31.1062 29.8843 32.5752 28.6924C34.1843 27.3868 34.1901 23.3854 34.25 21.4473C34.3215 19.1544 34.39 14.2955 33.4023 12.2881C32.001 9.44074 26.6502 10.3731 24.0439 10L15.3662 10.0215ZM24.6523 19.9727L17.0547 24.2363V15.709L24.6523 19.9727Z",
    fill: "#FF0909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3663 10.0218L24.0442 10C26.6504 10.3731 32.0013 9.44028 33.4027 12.2876C34.3906 14.2951 34.321 19.155 34.2495 21.4477C34.1896 23.3859 34.1845 27.3873 32.5751 28.6927C31.1062 29.8846 28.0652 29.7371 26.2286 29.8115C21.4199 30.0051 16.286 30.1398 11.4843 29.7493C8.3307 29.4929 6.74777 29.2306 6.13726 25.8402C5.67487 23.2756 5.65555 20.3321 5.78113 17.7258C5.87 15.8902 5.99107 12.4152 7.52056 11.1868C9.2323 9.81343 13.2476 10.3372 15.3663 10.0218ZM17.0542 24.2361L24.6521 19.9724L17.0542 15.7088V24.2361Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.13f3aa00d52dd174f2f7e996861bb7d0.svg";
export { ForwardRef as ReactComponent };